import { AppConfig } from './../../app/app.config';
import { Component } from '@angular/core';
import { NavController, AlertController, PopoverController, Platform } from 'ionic-angular';
import { FormBuilder, Validators } from '@angular/forms';
import { StorageService } from './../../providers/storage.service';
import { LoaddingService } from './../../providers/loadding.service';
import { AlertService } from './../../providers/alert.service';
import { SigninService } from './../../services/signin.service';
import { SysconfigService } from './../../services/sysconfig.service';
import { AgreeMsg, UserList } from './agreemsg';
import * as uuid from "uuid";
import { ImService } from '../im/im.service';
import { AppInfo } from '../../models/user.model';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { RegistPage } from '../regist/regist';
import { slideBlockCommon } from './slide-block/slideBlock';
import { SliderCaptchaPage } from './slider-captcha/slider-captcha';
import { LotteryService } from '../../services/lottery.service';

@Component({
    selector: 'page-signin',
    templateUrl: 'signin.html',
    providers: [SigninService, SysconfigService, LotteryService]
})
export class SigninPage {
    autourl = [];
    ping1 = 0;
    isshowyzm: boolean = false;
    lastUser: UserList = new UserList();
    users: UserList[] = [];
    requestTime = new Date().getTime();
    downloadUrl = '';
    customServiceUrl: string;
    wapUrl = [];
    isEnable: boolean = false;
    hijackingUrl: string;
    loginForm = this.formBuilder.group({
        'UserName': [this.lastUser.username, [Validators.required]],
        'Password': [this.lastUser.pwd, [Validators.required]],
        'Captcha': '',
        'remeberPwd': [false],
        'ping': [this.autourl[0]]
    });

    // 验证码刷新定时器
    captchaTimer = null;
    sum_count: number = 118; // 倒计时两分钟

    captchaId: string = null;
    captchaSrc: string = null;
    showZhongWen: boolean = false;
    catchId = uuid();
    /** 图片验证是否成功 */
    validateStatus: boolean;
    showCaptcha: boolean = false;
    loginNeedSecurityImage: boolean = false;            // 登录是否显示滑块验证按钮
    loginSecurityImageResult: boolean = false;          // 登录滑块验证验证结果
    loginTextFlag: boolean = false;                     // 登录滑块验证按钮文字
    platformsArr;
    isAndroidWap: boolean;
    isAppScreen: boolean;
    downClick = false;
    isWap = AppConfig.isWap;
    test = '';
    constructor
        (
            public navCtrl: NavController,
            private formBuilder: FormBuilder,
            private loadingService: LoaddingService,
            private alert: AlertService,
            private signinService: SigninService,
            private storage: StorageService,
            private config: AppConfig,
            private lotteryService: LotteryService,
            private alertCtrl: AlertController,
            private sysconfig: SysconfigService,
            private iab: InAppBrowser,
            private popoverCtrl: PopoverController,
            public platform: Platform,
        ) {
        // localStorage.removeItem('lotterys');
        if (this.storage.readString("Users")) {
            const userArrStr = AppConfig.decodeBase64(this.storage.readString("Users"));
            if (userArrStr) {
                this.users = JSON.parse(userArrStr);
            }
            if (this.users != null && this.users.length > 0) {
                this.lastUser = this.users[0];
            };
        }
        this.customServiceUrl = '';
        this.getServiceHall();
        clearInterval(ImService.getMessageCount);
        this.platform.ready().then(() => {
            this.platformsArr = this.platform.platforms();
            console.log(this.platformsArr);
        })
        // this.isAndroidWap = window.matchMedia('(display-mode: standalone)').matches;
        if (window.hasOwnProperty("AndroidInterface")) {
            // 属性存在
            this.isAndroidWap = true;
        } else {
            this.isAndroidWap = false;

            // 属性不存在
        }
    }

    getMarksixSettings() {
        this.lotteryService.getSixSetting().then((settings) => {
            if (!settings) {
                return;
            }
            let year = Number(settings.LiuhecaiHXDate);
            AppConfig.markSixYear = year > 1900 ? year : new Date().getFullYear();
            AppConfig.markSixPrevYear = AppConfig.markSixYear - 1;
            this.storage.write("markSixInfo", settings);
        }).catch(() => {
            AppConfig.markSixYear = new Date().getFullYear();
            AppConfig.markSixPrevYear = AppConfig.markSixYear - 1;
        });
    }


    ionViewDidLoad() {
        this.refreshCaptcha();
        this.getPlatformLineList()
        this.register();
        this.initScreen();
        if (!AppConfig.GetHostUrl()) {
            let appload = this.loadingService.showLoding();
            this.sysconfig.GetPhoneSettings(null).then((s: AppInfo) => {
                let u = navigator.userAgent;
                // 判断终端设备
                var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端
                var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                if (isAndroid) {
                    AppConfig.downloadUrl = s.AndroidUrl;
                    this.downloadUrl = s.AndroidUrl;
                }
                if (isiOS) {
                    AppConfig.downloadUrl = s.IosUrl;
                    this.downloadUrl = s.IosUrl;
                }
                this.loadingService.closeLoading(appload);
            }).catch(e => {
                this.loadingService.closeLoading(appload);
            })
        }
    }

    refreshCaptcha() {
        this.captchaId = uuid();
        this.captchaId = this.captchaId;
        this.captchaSrc = AppConfig.GetProdUrl() + '/auth/ValidateCode?id=' + this.captchaId;
        // clearInterval(this.captchaTimer);
        // this.captchaTimer = null;
        // this.refreshCode();
    }


    refreshCode() {
        let count = this.sum_count;
        if (!this.captchaTimer) {
            this.captchaTimer = setInterval(() => {
                if (count > 1 && count <= this.sum_count) {
                    count--;
                } else {
                    clearInterval(this.captchaTimer);
                    this.captchaTimer = null;
                    this.refreshCaptcha();
                }
            }, 1000)
        }
    }


    //用户名的blur事件
    usernameBlur() {
        if (this.users != null) {
            let curUser = this.users.find(s => s.username == this.loginForm.value.UserName);
            if (curUser) {
                this.lastUser.pwd = curUser.pwd;
            }
        }
    }

    login() {
        var user = {
            "username": this.loginForm.value.UserName,
            "password": this.loginForm.value.Password,
            'captcha': this.loginForm.value.Captcha,
            'captchaId': this.captchaId
        };
        this.signin(user);
    }

    signin(user: any) {
        if (this.showZhongWen && this.validateStatus == false) {
            return this.alert.showAlert('请先进行验证，通过后在登录。')
        }
        if (this.loginNeedSecurityImage && this.loginSecurityImageResult == false) {
            return this.alert.showAlert('请先进行验证，通过后在登录。')
        }
        const loading = this.loadingService.showLoding("登录中...");
        this.signinService.login(user).then(data => {
            if (data) {
                this.storage.writeString("token", data.access_token);
                this.getMarksixSettings();
                this.afkUrl();
                this.signinService.getUserModel().then(s => {
                    this.navCtrl.push(AgreeMsg, {
                        user: s,
                        token: data.access_token,
                        users: {
                            username: user.username,
                            pwd: user.password,
                            remeberpwd: this.loginForm.value.remeberPwd
                        }
                    });
                    this.storage.writeString("userpwd", AppConfig.encodeBase64(this.loginForm.value.Password));
                    this.loadingService.closeLoading(loading);
                }).catch(() => {
                    this.loadingService.closeLoading(loading);
                });
            } else {
                this.alert.showAlert(data.json().error_description, '温馨提示', false);
            }
        }).catch(data => {
            this.loadingService.closeLoading(loading);
            if (data.json().error == "3") {
                this.showGoogleValidator();
            } if (data.json().error == "96") {
                this.isshowyzm = true;
                this.alert.showAlert(data.json().error_description, '温馨提示', false);
                return;
            } else if (data.json().error == "5-2") {
                // this.alert.showAlert(data.json().error_description);
                this.refreshCaptcha();
                this.showZhongWen = true;

                this.alert.showAlert(data.json().error_description, '温馨提示', false);
                // 验证失败
                this.validateStatus = false;
            } else if (data.json().error == "5-1") {
                this.loginSecurityImageResult = false;
                this.loginNeedSecurityImage = true;
                this.alert.showAlert(data.json().error_description, '温馨提示', false);
            }


            else if (data.json().error == "5") {
                this.alert.showAlert(data.json().error_description, '温馨提示', false);
                this.refreshCaptcha();
            } else {
                this.loginSecurityImageResult = false;
                this.validateStatus = false;
                this.alert.showAlert(data.json().error_description, '温馨提示', false);
            }
        });
    }

    /**
     * 是否需要滑块验证码
     */
    onLoginNeedSecurityImage() {
        const popover = this.popoverCtrl.create(slideBlockCommon, {}, { cssClass: "check-captcha-component" }
        );
        popover.present();
        popover.onDidDismiss((data: any) => {
            if (data && data.catchId && data.authSuccess) {
                this.loginSecurityImageResult = data.authSuccess;
                this.captchaId = data.catchId;
            }
        });
    }

    showCaptchaModal() {
        const model = this.popoverCtrl.create(SliderCaptchaPage, {
            validateStatus: this.validateStatus,
        });
        model.present();
        model.onWillDismiss((data: any[]) => {
            if (data) {
                if (this.validateStatus == true) {
                    this.showCaptcha = true;
                }
            }
        });
    }
    /**
 *
 * 验证成功 登录密码还是错误的情况下
 * @param {*} val 执行后的返回结果
 * @memberof LoginComponent
 */
    validateStatusChange(val) {
        this.validateStatus = val;
    }
    getCaptchaId(Id) {
        this.captchaId = Id;
    }
    // 获取是否开启挂机与地址、刷新挂机
    afkUrl() {
        this.sysconfig.getHangonTool().then(s => {
            if (s.Value) {
                this.storage.writeString('AfkURL', s.Data.toString().trim());
            } else { this.storage.remove('AfkURL'); }
        }).catch(err => { this.storage.remove('AfkURL'); })
    }

    private showGoogleValidator() {
        let prompt = this.alertCtrl.create({
            title: '谷歌登录器',
            message: "请输入动态验证码",
            inputs: [{ name: 'cknum', placeholder: '动态验证码' }],
            buttons: [
                { text: '取消' },
                {
                    text: '确认', handler: data => {
                        var cknum: string = data.cknum;
                        if (cknum == null || cknum.trim() == "") {
                            this.alert.showAlert("请输入动态验证码", '温馨提示', false);
                        } else {
                            const user = {
                                "username": this.loginForm.value.UserName,
                                "password": this.loginForm.value.Password,
                                'captcha': this.loginForm.value.Captcha,
                                'gasecret': cknum,
                                'captchaId': this.captchaId
                            };
                            this.signin(user)
                        }
                    }
                }
            ]
        });
        prompt.present();
    }

    getServiceHall() {
        this.sysconfig.getServiceHall().then(s => {
            if (s) {
                this.customServiceUrl = s.CustomerServiceUrl;
            }
        })
    }
    //在线客服
    //TQQ 2017-01-19
    customer() {
        if (this.customServiceUrl) {
            this.config.openUrl(this.customServiceUrl);
        }
    }

    //域名检测
    //chen 2017-03-15
    // realm() {
    //   this.navCtrl.push(Realm);
    // }

    download() {
        this.config.openUrl(AppConfig.downloadUrl);
    }


    getPlatformLineList() {
        this.sysconfig.getPlatformLineList().then(res => {
            if (res) {
                res.forEach(item => {
                    if (item.LineType == 3) {
                        this.wapUrl.push(item);
                    } else if (item.LineType == 6) {
                        this.hijackingUrl = item.LineUrl
                    }
                });
            }

        })
    }

    // 立即注册
    register() {
        this.sysconfig.register().then((s) => {
            this.storage.writeString("registerURL", s.RegisterUrl);
            if (s.Enable === true) {
                this.isEnable = true;
            } else if (s.Enable === false) {
                this.isEnable = false;
            }
        });
    }
    registerURl() {
        let url = this.storage.readString("registerURL");
        let firstUrl = this.wapUrl[0].LineUrl;
        // let url2 = url.substr(0, url.lastIndexOf("/") + 1);
        // let url3 = url.replace(url2, firstUrl + '?Key=');
        // console.log(firstUrl,url2,url3)
        // this.alert.showConfirm('此链接为平台官方注册链接，若您通过本平台代理进行开户注册，将可获得更高的奖金与返点喔！',()=>{
        // window.open(url3, "'_system");
        let url2 = url.split('ey=')[1];
        let url3 = this.wapUrl[0].LineUrl + '/Regist?Key=' + url2;
        this.navCtrl.push(RegistPage, { key: url2 })
        // this.iab.create(url3, '_system');
        // },'温馨提示')
    }
    hijackingLink() {
        window.open('https://www.xb888888.com/domains?platform=xinbao5')
    }
    initScreen() {
        if ((window.navigator as any).standalone || false) {
            this.isAppScreen = true
        } else {
            this.isAppScreen = false;
        }
    }
    /**
    * 中文验证
    */
    onLoginChineseNeedSecurity() {
        const popover = this.popoverCtrl.create(SliderCaptchaPage, {}, { cssClass: "chinese-need-Security" }
        );
        popover.present();
        popover.onDidDismiss((data: any) => {
            console.log(data);
            if (data) {
                this.validateStatus = data.authSuccess;
                this.captchaId = data.catchId;
                // this.code = data.code
            }

        });
    }
}





// WEBPACK FOOTER //
// ./src/pages/signin/signin.ts